// extracted by mini-css-extract-plugin
export default {"green":"styles_green__Ov2Es","blank":"styles_blank__t8V9q","blue":"styles_blue__8qHCG","red":"styles_red__7ah8i"};